// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3cHCu","header":"ClearentDisclaimer_header__12vVg","inner":"ClearentDisclaimer_inner__Zi4yr"};